import { initializeApp } from 'firebase/app';
import { getFirestore, collection, onSnapshot, orderBy, query, updateDoc, doc, addDoc, increment } from "firebase/firestore";
import { useState, useEffect } from 'react';

const useChat = (currentChat, index) => {
    const [messages, setMessages] = useState([]);
    const [loading, setLoading] = useState(false);

    const firebaseConfig = {
        apiKey: "AIzaSyD0dRAy30uqOBPB8TG2Yt3MtGr5d07Dy5E",
        authDomain: "pnp-programa-nutricional.firebaseapp.com",
        databaseURL: "https://pnp-programa-nutricional.firebaseio.com",
        projectId: "pnp-programa-nutricional",
        storageBucket: "pnp-programa-nutricional.appspot.com",
        messagingSenderId: "739635922755",
        appId: "1:739635922755:web:49c1c5ec2ae5e18e5651f6",
        measurementId: "G-6Q2W3E05HV"
    };

    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);
    const db = getFirestore(firebaseApp);

    const setWasRead = async () => {
        if (currentChat && !currentChat.was_read_adm) {
            try {
                const userDocRef = doc(db, 'users', String(currentChat.id));
                await updateDoc(userDocRef, {
                    was_read_adm: true
                });
            } catch (error) {
                console.error("Error setting chat as read:", error);
            }
        }
    }

    const sendMessage = async (messageText) => {
        try {
            const newDate = new Date();
            const userDocRef = doc(db, 'users', String(currentChat.id));

            // Update the parent user document
            await updateDoc(userDocRef, {
                last_message: newDate,
                unread_messages: increment(1),
                was_read_adm: true
            });

            // Add the new message to the messages subcollection
            const messagesCollectionRef = collection(userDocRef, 'messages');
            await addDoc(messagesCollectionRef, {
                created_at: newDate,
                send_by_user: false,
                text: messageText
            });
        } catch (error) {
            console.error('ERROR CREATE MESSAGE', error);
        }
    }

    useEffect(() => {
        if (!currentChat || !currentChat.id) return;

        setLoading(true);
        setWasRead(); // Set as read when the chat is opened/loaded

        const userDocRef = doc(db, 'users', String(currentChat.id));
        const messagesCollectionRef = collection(userDocRef, 'messages');
        const q = query(messagesCollectionRef, orderBy('created_at', 'asc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const msgs = snapshot.docs.map(doc => doc.data());
            setMessages(msgs);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching messages:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [currentChat]);

    return { messages, loading, sendMessage };
}

export { useChat }
